// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TradeSpecificAgreementQueryVariables = Types.Exact<{
  costDivisionId: Types.Scalars['ID']['input'];
  tradePartnerId: Types.Scalars['ID']['input'];
}>;


export type TradeSpecificAgreementQuery = { __typename?: 'Query', costDivisions: Array<{ __typename?: 'CostDivision', id: string, displayName: string, tsaPolicySection?: string | null | undefined, tsaGeneralScope?: string | null | undefined, tsaPaymentSection?: string | null | undefined, tsaWarrantySection?: string | null | undefined, costCodes: Array<{ __typename?: 'CostCode', id: string, displayName: string, tsaSpecifications?: string | null | undefined }> }>, tradePartner: { __typename?: 'TradePartner', id: string, name: string } };

export type TradeSpecificAgreementCostDivisionFragment = { __typename?: 'CostDivision', id: string, displayName: string, tsaPolicySection?: string | null | undefined, tsaGeneralScope?: string | null | undefined, tsaPaymentSection?: string | null | undefined, tsaWarrantySection?: string | null | undefined, costCodes: Array<{ __typename?: 'CostCode', id: string, displayName: string, tsaSpecifications?: string | null | undefined }> };

export type TradeSpecificAgreementCostCodeFragment = { __typename?: 'CostCode', id: string, displayName: string, tsaSpecifications?: string | null | undefined };

export const TradeSpecificAgreementCostCodeFragmentDoc = gql`
    fragment TradeSpecificAgreementCostCode on CostCode {
  id
  displayName
  tsaSpecifications
}
    `;
export const TradeSpecificAgreementCostDivisionFragmentDoc = gql`
    fragment TradeSpecificAgreementCostDivision on CostDivision {
  id
  displayName
  tsaPolicySection
  tsaGeneralScope
  tsaPaymentSection
  tsaWarrantySection
  costCodes {
    ...TradeSpecificAgreementCostCode
  }
}
    ${TradeSpecificAgreementCostCodeFragmentDoc}`;
export const TradeSpecificAgreementDocument = gql`
    query TradeSpecificAgreement($costDivisionId: ID!, $tradePartnerId: ID!) {
  costDivisions(filter: {id: [$costDivisionId]}) {
    ...TradeSpecificAgreementCostDivision
  }
  tradePartner(id: $tradePartnerId) {
    id
    name
  }
}
    ${TradeSpecificAgreementCostDivisionFragmentDoc}`;

/**
 * __useTradeSpecificAgreementQuery__
 *
 * To run a query within a React component, call `useTradeSpecificAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeSpecificAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeSpecificAgreementQuery({
 *   variables: {
 *      costDivisionId: // value for 'costDivisionId'
 *      tradePartnerId: // value for 'tradePartnerId'
 *   },
 * });
 */
export function useTradeSpecificAgreementQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradeSpecificAgreementQuery, TradeSpecificAgreementQueryVariables> & ({ variables: TradeSpecificAgreementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradeSpecificAgreementQuery, TradeSpecificAgreementQueryVariables>(TradeSpecificAgreementDocument, options);
      }
export function useTradeSpecificAgreementLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradeSpecificAgreementQuery, TradeSpecificAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradeSpecificAgreementQuery, TradeSpecificAgreementQueryVariables>(TradeSpecificAgreementDocument, options);
        }
// @ts-ignore
export function useTradeSpecificAgreementSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TradeSpecificAgreementQuery, TradeSpecificAgreementQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradeSpecificAgreementQuery, TradeSpecificAgreementQueryVariables>;
export function useTradeSpecificAgreementSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradeSpecificAgreementQuery, TradeSpecificAgreementQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradeSpecificAgreementQuery | undefined, TradeSpecificAgreementQueryVariables>;
export function useTradeSpecificAgreementSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradeSpecificAgreementQuery, TradeSpecificAgreementQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradeSpecificAgreementQuery, TradeSpecificAgreementQueryVariables>(TradeSpecificAgreementDocument, options);
        }
export type TradeSpecificAgreementQueryHookResult = ReturnType<typeof useTradeSpecificAgreementQuery>;
export type TradeSpecificAgreementLazyQueryHookResult = ReturnType<typeof useTradeSpecificAgreementLazyQuery>;
export type TradeSpecificAgreementSuspenseQueryHookResult = ReturnType<typeof useTradeSpecificAgreementSuspenseQuery>;
export type TradeSpecificAgreementQueryResult = ApolloReactCommon.QueryResult<TradeSpecificAgreementQuery, TradeSpecificAgreementQueryVariables>;